<template>
    <div>
        <!-- Modal Component -->
        <b-modal id="modal-notice" hide-header footer-text-variant="doei">
            <div v-if="notice" class="text-center">
                <img v-if="notice.type === 'christmas'" src="/images/brand/elektrobode-kerst-logo.svg" class="img-fluid">
                <p class="my-4 text-center" v-html="notice.post_content"></p>
            </div>
            <div slot="modal-footer" class="w-100 justify-content-center text-center">
                <b-btn size="sm" variant="primary" @click="closeModal()">
                    Doorgaan naar winkel
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: [],

        /*
         * The component's data.
         */
        data() {
            return {
                notices: [],
                notice: null
            }
        },

        /**
         * Prepare the component (Vue 1.x).
         */
        ready() {
            this.prepareComponent();
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            /**
             * Prepare the component (Vue 2.x).
             */
            prepareComponent() {
                this.setNotices(window.NoticeService.getNotices());

                bus.$on('notices:loaded', function(notices) {
                    this.setNotices(notices);
                }.bind(this));
            },

            /**
             * Get all of the authorized tokens for the user.
             */
            setNotices(notices) {
                if (!notices) {
                    return;
                }

                this.loading = false;
                this.notices = notices;

                var self = this;

                this.notices.forEach(function(notice) {
                    if (notice.show_modal !== '1') {
                        return;
                    }

                    if (self.getCookie('modal-notice' + notice.ID) === '') {
                        self.notice = notice;
                        self.$root.$emit('bv::show::modal', 'modal-notice');

                        self.createCookie('modal-notice' + notice.ID, true, 30);
                    }
                });
            },

            closeModal() {
                this.$root.$emit('bv::hide::modal', 'modal-notice');
            },

            createCookie (name, value, days) {
                let expires;
                if (days) {
                    let date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toGMTString();
                }
                else {
                    expires = "";
                }
                document.cookie = name + "=" + value + expires + "; path=/";
            },

            getCookie(c_name) {
                if (document.cookie.length > 0) {
                    let c_start = document.cookie.indexOf(c_name + "=");
                    if (c_start !== -1) {
                        c_start = c_start + c_name.length + 1;
                        let c_end = document.cookie.indexOf(";", c_start);
                        if (c_end === -1) {
                            c_end = document.cookie.length;
                        }
                        return unescape(document.cookie.substring(c_start, c_end));
                    }
                }
                return "";
            },
        }
    }
</script>
